var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"objects__info block"},[_c('div',{staticClass:"account-info"},[_c('div',{staticClass:"account-info__item"},[_c('div',{staticClass:"account-info__label"},[_vm._v("Порядок расчета по договору:")]),_vm._v(" "),_c('div',{staticClass:"account-info__value"},[_vm._v("\n                до 10 числа месяца, следующего за расчетным.\n            ")])])])])
}]

export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./Scripts/app/fl/components/account-paymentprocedure.vue